import type { CalculatedMaterial } from "./types";

export function frameMemberSide(label: string) {
  return ({ "Верхняя часть рамы": "Верх", "Нижняя часть рамы": "Низ", "Левая часть рамы": "Лево", "Правая часть рамы": "Право" } as Record<string, string>)[label];
}

// Native rows are grouped by article, not top/bottom/left/right. In particular
// facades and sliding frames have different articles on different members.
export function frameMemberLengths(materials: CalculatedMaterial[], widthMm: number, heightMm: number) {
  const pieces = materials.filter(m => m.visualPart === "frame" && m.category === "Profile")
    .flatMap(m => m.pieces ?? []);
  return ["Верх", "Низ", "Лево", "Право"].map((side, i) =>
    pieces.find(p => p.side === side)?.lengthMm ?? (i < 2 ? widthMm : heightMm));
}

export function isVerifiedFacade(materials: CalculatedMaterial[]) {
  const codes = new Set(materials.map(m => m.code));
  return (codes.has("RX 6206") && codes.has("RX 6402")) || (codes.has("RX 6217") && codes.has("RX 6070-01"));
}

export function sashMemberLengths(materials:CalculatedMaterial[],location:string) {
  const pieces=materials.filter(m=>m.visualPart==="sash"&&m.category==="Profile").flatMap(m=>m.pieces??[]).filter(p=>p.location===location);
  const top=pieces.find(p=>p.side==="Верх"),side=pieces.find(p=>p.side==="Лево");
  return top&&side?{top:top.lengthMm,side:side.lengthMm}:undefined;
}
